import { render } from "./pay-order.vue?vue&type=template&id=36306096&scoped=true"
import script from "./pay-order.vue?vue&type=script&lang=js"
export * from "./pay-order.vue?vue&type=script&lang=js"

import "./pay-order.vue?vue&type=style&index=0&id=36306096&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\yuanxi\\yuanxi-zju\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36306096"]])

export default __exports__